import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

import { storeFCMToken } from "./services/api";

const firebaseConfig = {
  apiKey: "AIzaSyAh30TGBnwmnyZ3et007kxdYgF5yLm0208",
  authDomain: "sats-sjc.firebaseapp.com",
  projectId: "sats-sjc",
  storageBucket: "sats-sjc.firebasestorage.app",
  messagingSenderId: "902275950270",
  appId: "1:902275950270:web:833bbb5deda362750e20ef",
};

const firebaseApp = initializeApp(firebaseConfig);
const messaging = getMessaging(firebaseApp);

export const requestNotificationPermission = async () => {
  try {
    const permission = await Notification.requestPermission();
    if (permission === "granted") {
      return true;
    }
    return false;
  } catch (error) {
    console.error("Erro ao solicitar permissão:", error);
    return false;
  }
};

export const fetchToken = async (userId) => {
  try {
    const hasPermission = await requestNotificationPermission();
    if (!hasPermission) {
      console.log("Permissão para notificações não concedida");
      return null;
    }

    const currentToken = await getToken(messaging, {
      vapidKey:
        "BED35-smWenMfUXeCE5aag2kkpTeqJiAZqVWqdWKmXRgECWmwih2UZtMdc2v1P4L6y_CTIzIyfnB6LYNzGyZ08Y",
    });

    if (currentToken) {
      console.log("Token FCM obtido com sucesso");
      await storeFCMToken(userId, currentToken);
      return currentToken;
    } else {
      console.log(
        "Não foi possível obter o token de registro. Solicite permissão para gerar um."
      );
      return null;
    }
  } catch (err) {
    console.error("Erro ao obter token:", err);
    return null;
  }
};

export const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      console.log("Mensagem recebida em primeiro plano:", payload);
      resolve(payload);
    });
  });
